import React, { useState, Children, memo } from 'react';
import { ChevronDown, Phone, User, Menu, X } from 'lucide-react';
type Category = {
  name: string;
  url: string;
};
const productCategories: Category[] = [{
  name: 'Anti-Aging Vitamins',
  url: 'https://www.bestvitaminsforall.com/bestantiagingvitamins'
}, {
  name: 'Body Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-body-care-products.html'
}, {
  name: 'Memory Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-brain-memory-supplements.html'
}, {
  name: 'Children Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-children-supplements.html'
}, {
  name: 'Digestion Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-digestion-supplements.html'
}, {
  name: 'Energy Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-energy-vitamins-supplements.html'
}, {
  name: 'Eyes & Vision',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-eyes-vision.html'
}, {
  name: 'Fiber Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-fiber-supplements.html'
}, {
  name: 'Heart Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-heart-supplements.html'
}, {
  name: 'Herbal Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-herbal-supplements.html'
}, {
  name: 'Home Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-home-care-products.html'
}, {
  name: 'Immune Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-immune-supplements.html'
}, {
  name: 'Mineral Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-mineral-supplements.html'
}, {
  name: 'Multi-Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-multi-vitamins.html'
}, {
  name: 'Natural Oils',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-natural-oils.html'
}, {
  name: 'Single Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-single-vitamins.html'
}, {
  name: 'Skin Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-skin-care.html'
}, {
  name: 'Sports Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-sports-supplements.html'
}, {
  name: 'Vegan Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegan-vitamins-supplements.html'
}, {
  name: 'Vegetarian Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegetarian-supplements.html'
}, {
  name: 'Weight Loss Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-weight-loss-supplements.html'
}, {
  name: 'Protein Shakes',
  url: 'https://www.bestvitaminsforall.com/15m8/neolife-protein-shakes.html'
}, {
  name: 'Organic Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/organic-vitamins.html'
}];
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);
  // Split categories into columns for desktop (4 columns)
  const columnsCount = 4;
  const itemsPerColumn = Math.ceil(productCategories.length / columnsCount);
  const columns: Category[][] = [];
  for (let i = 0; i < columnsCount; i++) {
    columns.push(productCategories.slice(i * itemsPerColumn, (i + 1) * itemsPerColumn));
  }
  return <header className="bg-white shadow-sm sticky top-0 z-50 font-sans" data-id="element-62">
      {/* Top Bar - Mobile Only */}
      <div className="md:hidden bg-[#0e7be1] text-white py-2 px-4 text-center text-sm font-medium" data-id="element-63">
        Call us: 800-260-2808
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex justify-between items-center h-14 lg:h-16" data-id="element-65">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-3" data-id="element-66">
            <a href="/" className="flex items-center" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/1hCDA3zzdjWRL7TqBKyeWc/Best-Vitamins-For-All.webp" alt="Best Vitamins For All" className="h-6 lg:h-7 w-auto" data-id="element-68" />
            </a>
            <img src="https://cdn.magicpatterns.com/uploads/ssrgMdZGi9uTcmdb8AVR45/GNLD-secondary-logo.webp" alt="GNLD NeoLife" className="h-8 lg:h-10 w-auto" data-id="element-69" />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6" data-id="element-70">
            <div className="relative" onMouseEnter={() => setIsProductMenuOpen(true)} onMouseLeave={() => setIsProductMenuOpen(false)} data-id="element-71">
              <button className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium inline-flex items-center transition-colors" data-id="element-72">
                GNLD NeoLife Products
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${isProductMenuOpen ? 'rotate-180' : ''}`} data-id="element-73" />
              </button>

              {/* Mega Menu Dropdown - Multi-column */}
              <div className={`absolute left-1/2 -translate-x-1/2 mt-0 pt-2 transition-all duration-150 ${isProductMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}`} data-id="element-74">
                <div className="bg-white shadow-xl ring-1 ring-gray-200 rounded-lg overflow-hidden min-w-[700px]" data-id="element-75">
                  <div className="p-6" data-id="element-76">
                    <div className="grid grid-cols-4 gap-x-8 gap-y-1" data-id="element-77">
                      {columns.map((column, colIndex) => <div key={colIndex} className="space-y-1" data-id="element-78">
                          {column.map(category => <a key={category.name} href={category.url} className="block py-2 text-sm text-gray-600 hover:text-[#0e7be1] transition-colors whitespace-nowrap" data-id="element-79">
                              {category.name}
                            </a>)}
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <a href="#" className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium transition-colors" data-id="element-80">
              Join
            </a>
            <a href="#" className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium transition-colors" data-id="element-81">
              Contact Us
            </a>
            <a href="#" className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium transition-colors" data-id="element-82">
              About Us
            </a>
            <a href="#" className="text-gray-700 hover:text-[#0e7be1] py-2 text-sm font-medium transition-colors" data-id="element-83">
              Resources
            </a>
          </nav>

          {/* Right Side Info */}
          <div className="hidden lg:flex items-center space-x-5" data-id="element-84">
            <a href="tel:800-260-2808" className="flex items-center text-gray-700 hover:text-[#0e7be1] font-medium text-sm transition-colors" data-id="element-85">
              <Phone className="h-4 w-4 mr-2 text-[#0e7be1]" data-id="element-86" />
              800-260-2808
            </a>
            <a href="#" className="flex items-center text-gray-700 hover:text-[#0e7be1] font-medium text-sm transition-colors" data-id="element-87">
              <User className="h-4 w-4 mr-1" data-id="element-88" />
              Sign In
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-89">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-[#0e7be1] hover:bg-gray-100 focus:outline-none" aria-label="Toggle menu" data-id="element-90">
              {isMenuOpen ? <X className="h-6 w-6" data-id="element-91" /> : <Menu className="h-6 w-6" data-id="element-92" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 max-h-[80vh] overflow-y-auto" data-id="element-93">
          <div className="px-4 py-3" data-id="element-94">
            <div className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-2" data-id="element-95">
              Products
            </div>
            <div className="space-y-0" data-id="element-96">
              {productCategories.map(category => <a key={category.name} href={category.url} className="block py-2.5 text-sm text-gray-600 hover:text-[#0e7be1] border-b border-gray-50 last:border-0" data-id="element-97">
                  {category.name}
                </a>)}
            </div>
            <div className="border-t border-gray-100 mt-4 pt-4 space-y-0" data-id="element-98">
              <a href="#" className="block py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-99">
                Join
              </a>
              <a href="#" className="block py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-100">
                Contact Us
              </a>
              <a href="#" className="block py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-101">
                About Us
              </a>
              <a href="#" className="block py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-102">
                Resources
              </a>
              <a href="#" className="block py-2.5 text-sm font-medium text-gray-700 hover:text-[#0e7be1]" data-id="element-103">
                Sign In
              </a>
            </div>
          </div>
        </div>}
    </header>;
}